export default {
  cancelDialog: {
    title: '取消「{{studyName}}」？',
    description:
      '模擬將不會提交。您的網格會保留在 MeshGen 中，不會刪除任何內容。',
    alreadyProduced: '已產生（保留）',
    openInMeshGen: '在 MeshGen 中開啟',
    keepStudy: '保留研究',
    confirmCancel: '取消研究並保留網格',
  },
  completionDialog: {
    eyebrow: '執行模擬',
    title_one: '將 {{count}} 個設計點提交至求解器？',
    title_other: '將 {{count}} 個設計點提交至求解器？',
    description: '您隨時可以回到網格劃分，但新的模擬執行將使用下方所附的網格。',
    facesNamed: '{{cells}} · 已命名 {{faces}}',
    needsMeshing: '需要網格劃分，將被略過',
    estimateLabel: '預估成本 · 時間',
    keepMeshing: '繼續網格劃分',
    runOnDps_one: '對 {{count}} 個設計點執行模擬',
    runOnDps_other: '對 {{count}} 個設計點執行模擬',
  },
  switcher: {
    ariaLabel: '設計點',
    moreCount: '再 +{{count}} 個',
    nextPending: '下一個待處理',
  },
  toasts: {
    cancelStudyPending: '取消研究功能尚未提供——介面已就緒，等待後端。',
    markDpPending: '標記設計點完成功能尚未提供——前往下一個待處理的設計點。',
  },
  journey: {
    ariaLabel: '研究流程',
    remeshTooltip_one: '{{count}} 個設計點待重新網格劃分',
    remeshTooltip_other: '{{count}} 個設計點待重新網格劃分',
    remeshBadge: '{{count}} 個待重劃',
    youAreHere: '目前位置',
    skipped: '已略過',
    stepMeshSub: '健康度 + 設定',
    stepSimulateSub: '參數 + 執行',
    stepResultsSub: '分析',
  },
  status: {
    notStarted: '尚未開始',
    meshing: '網格劃分中',
    meshReady: '網格就緒，請命名面',
    facesDone: '就緒',
    failed: '失敗',
  },
  completionBar: {
    thisDp: '此設計點',
    meshProduced: '已產生網格',
    allFacesNamed: '所有面已命名',
    markDpComplete: '標記設計點完成',
    studyProgress: '研究進度',
    completeAndRun: '完成並執行模擬',
  },
  progressList: {
    colDp: '設計點',
    colGeometry: '幾何 / 變體',
    colMesh: '網格',
    colFaceNaming: '面命名',
    colStatus: '狀態',
    colAction: '操作',
    failedInMesh: '網格劃分失敗',
    namingInProgress: '命名進行中',
    facesNamed: '已命名 {{faces}}',
    allNamed: '全部已命名',
    currentlyOpen: '目前開啟中',
    reopen: '重新開啟',
    openInMeshGen: '在 MeshGen 中開啟',
    viewInMeshGen: '在 MeshGen 中檢視',
  },
  resumeCard: {
    ariaLabel: '繼續網格劃分 — {{studyName}}',
    eyebrow: '繼續網格劃分',
    paused: '{{ago}}暫停',
    expiresIn: '{{time}}後到期',
    remaining_one: '剩餘 {{remaining}} / {{total}} 個幾何',
    remaining_other: '剩餘 {{remaining}} / {{total}} 個幾何',
    autoQueue: '網格劃分完成後模擬將自動排入佇列',
    resumeNextPending: '繼續下一個待處理',
    cancelStudy: '取消研究…',
  },
  tree: {
    removeFromRun: '從執行中移除網格',
    addToRun: '將網格加入執行',
    collapse: '收合',
    expand: '展開',
    remesh: '重新網格劃分',
    mesh: '網格',
    view: '檢視',
    review: '檢查',
    otherSimType: '其他模擬類型',
    notMeshedYet: '尚未網格劃分',
    meshLabel: '網格',
    refinementLabel: '細化',
  },
  contextBanner: {
    returnToStudy: '返回研究',
    studyMode: '研究模式',
    geometryOf: '幾何 {{index}} / {{total}}',
    nameFaceToCommit: '命名 1 個面以提交',
    ready: '就緒',
  },
  draftChrome: {
    geometryNotStarted: '尚未網格劃分',
    geometryLoading: '檢查中…',
    geometryProcessing: '準備中',
    geometryAwaitingApproval: '等待核准',
    geometryError: '無法產生網格',
    geometryMeshing: '網格劃分中',
    geometryCompleted: '就緒',
    geometryFailed: '失敗',
    fallbackStudyTitle: '研究',
    backToStudy: '返回研究',
    meshedProgress: '已完成 {{done}} / {{total}} 個網格',
    geomLabel: '幾何 {{index}} · {{status}}',
    allMeshed: '所有幾何皆已網格劃分。',
    meshAllToContinue: '請完成所有幾何的網格劃分以繼續。',
    continueToSimulate: '繼續至模擬',
    waitForPreparation_one: '正在等待 {{count}} 個仍在準備或需要處理的幾何。',
    waitForPreparation_other: '正在等待 {{count}} 個仍在準備或需要處理的幾何。',
  },
  studyChrome: {
    loadingContext: '正在載入研究內容…',
    errorContext:
      '無法載入此設計點的研究內容，工作區仍可使用，但研究框架已隱藏。',
    returnToStudy: '返回研究',
  },
  timeoutCard: {
    ariaLabel: '網格劃分工作階段逾時',
    title: '網格劃分工作階段逾時',
    badge: '失敗 · 已到期',
    body_one:
      '此研究處於「等待網格劃分」狀態達 7 天，因此我們已暫停。您已完成的 {{count}} 個網格安全保存在 MeshGen 中。您可以從中建立新研究以延續進度，網格匯入研究會重用您已完成的網格。',
    body_other:
      '此研究處於「等待網格劃分」狀態達 7 天，因此我們已暫停。您已完成的 {{count}} 個網格安全保存在 MeshGen 中。您可以從中建立新研究以延續進度，網格匯入研究會重用您已完成的網格。',
    startNewStudy: '從這些網格建立新研究',
    viewFinishedMeshes: '檢視已完成的網格',
    archiveStudy: '封存研究',
  },
} as const;
